import { NextPageContext } from 'next';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';

import { PLANK_COOKIE } from '~/src/constants';
import { getCookie } from '~/src/helpers/cookie';
import { getIsMobile } from '~/src/helpers/getIsMobile';
import { getIsActiveByTerms, getIsLocationByTerms } from '~/src/store/actions/plank';

export const processPlankState = (nextPageContext: NextPageContext): boolean | undefined => {
    if (!nextPageContext.req) {
        return;
    }

    const hasNotNotificationMobileAppCookie = getCookie(PLANK_COOKIE, nextPageContext.req);
    const hasAccessTokenCookie = getCookie(ACCESS_TOKEN_COOKIE, nextPageContext.req);

    const userAgent = nextPageContext.req.headers['user-agent'];
    const { asPath = '/' } = nextPageContext;
    const isMobileUserAgent = getIsMobile(userAgent);

    const isActiveByTerms = getIsActiveByTerms(asPath);
    const isLocationByTerm = getIsLocationByTerms(asPath);

    return Boolean(
        !hasNotNotificationMobileAppCookie && isActiveByTerms && isMobileUserAgent &&
        (hasAccessTokenCookie || isLocationByTerm),
    );
};
